import firebase from "firebase";
import { CURRENCY_CODE } from "../constants/DeliveryConstants";
import { getDiscountPriceWithDefault } from "./product";
import {
  ANALYTICS_ADD_TO_CART,
  ANALYTICS_SELECT_ITEM,
  RELATED_PRODUCTS_LIST_ID,
  RELATED_PRODUCTS_LIST_NAME,
} from "../constants/AnalyticsConstants";
import dayjs from "dayjs";

/**
 * Triggers select_item event when clicking on related product
 **/
export const setSelectRelatedProductAnalytics = (product, index) => {
  firebase.analytics().logEvent(ANALYTICS_SELECT_ITEM, {
    item_list_id: RELATED_PRODUCTS_LIST_ID,
    item_list_name: RELATED_PRODUCTS_LIST_NAME,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        currency: CURRENCY_CODE,
        discount:
          product.price -
          getDiscountPriceWithDefault(product.price, product.discount),
        index: index,
        item_list_id: RELATED_PRODUCTS_LIST_ID,
        item_list_name: RELATED_PRODUCTS_LIST_NAME,
        price: product.price,
        quantity: 1,
      },
    ],
  });
};

/**
 * Triggers add_to_cart event when adding related product directly to cart
 **/
export const setAddToCartAnalyticsRelatedProducts = (product, index) => {
  firebase.analytics().logEvent(ANALYTICS_ADD_TO_CART, {
    currency: CURRENCY_CODE,
    value: getDiscountPriceWithDefault(product.price, product.discount),
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        currency: CURRENCY_CODE,
        discount:
          product.price -
          getDiscountPriceWithDefault(product.price, product.discount),
        index: index,
        item_list_id: RELATED_PRODUCTS_LIST_ID,
        item_list_name: RELATED_PRODUCTS_LIST_NAME,
        price: product.price,
        quantity: 1,
      },
    ],
  });
};

/**
 * Dynamic analytics event for 1 specific item
 **/
export const setProductAnalyticsEvent = (
  eventName,
  product,
  quantity,
  categoryName,
) => {
  const value = getDiscountPriceWithDefault(product.price, product.discount);
  firebase.analytics().logEvent(eventName, {
    currency: CURRENCY_CODE,
    value: !!quantity ? value * quantity : value,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        item_category: categoryName,
        currency: CURRENCY_CODE,
        discount:
          product.price -
          getDiscountPriceWithDefault(product.price, product.discount),
        index: 0,
        price: product.price,
        quantity: !!quantity ? quantity : 1,
      },
    ],
  });
};

/**
 * POST Purchase event to FB conversions api
 **/
export const setFacebookPurchaseEvent = (totalValue) => {
  fetch(
    `https://graph.facebook.com/v12.0/${process.env.REACT_APP_FACEBOOK_PIXEL_ID}/events?access_token=${process.env.REACT_APP_FACEBOOK_CONVERSION_API_KEY}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: [
          {
            event_name: "Purchase",
            event_time: dayjs().unix(),
            action_source: "website",
            custom_data: {
              currency: CURRENCY_CODE,
              value: totalValue,
            },
          },
        ],
      }),
    },
  ).catch((error) => console.error(error));
};
